import _ from 'lodash';
import { refPlatformService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefPlatform() {
    return {
        refPlatformId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        itServiceCount: 0
    };
}

export const refplatforms = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefPlatform: getBlankRefPlatform()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refPlatformService.getByAccount(accountId)
                    .then(
                        refPlatforms => {
                            commit(GET_ALL_SUCCESS, refPlatforms);
                            resolve(refPlatforms);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refPlatformId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refPlatformService.getById(refPlatformId)
                    .then(
                        refPlatform => {
                            commit(GET_BY_ID_SUCCESS, refPlatform);
                            resolve(refPlatform);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refPlatform) {
            return refPlatformService.add(refPlatform);
        },
        [UPDATE]({ dispatch, commit }, refPlatform) {
            return refPlatformService.update(refPlatform);
        },
        [DELETE]({ dispatch, commit }, refPlatform) {
            return refPlatformService.deleteRefPlatform(refPlatform);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refPlatforms) {
            state.status = { loaded: true };
            state.items = refPlatforms;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refPlatform) {
            state.status = { loaded: true };
            state.currentRefPlatform = refPlatform;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefPlatform = getBlankRefPlatform();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefPlatform = getBlankRefPlatform();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefPlatform, {
                [field]: value
            });
        },
    }
}
